import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ActiveTour from "../../components/interActive/activeTour";
import CardInteractive from "../../components/interActive/cardInteractive";
import Modal from "../../components/modal/form-modal/modal";

function InteractiveTour({ lang }) {
  const [cardOpen, setCardOpen] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 770);

  const location = useLocation();
  const villa = location.state?.villa;

  const [isRTL, setIsRTL] = useState(lang === "ar");
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setIsRTL(lang === "ar");
  }, [lang]);
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width < 770);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div
      style={{
        background: "var(--foundation-black-light-active, #B0B0B0)",
        display: "flex",
        flexDirection: isMobile ? "column-reverse" : "row",
        height: isMobile ? "100vh" : "calc(100vh - 76px)",
        width: "100%",
        overflow: "hidden",
        position: "relative",
        padding: isMobile ? "0" : "0 18px",
        gap: isMobile ? "0" : cardOpen ? "18px" : "0px",
        direction: isRTL ? "rtl" : "ltr",
      }}
    >
      <div
        style={{
          width: isMobile ? "100%" : "336px",
          minWidth: isMobile ? "100%" : "336px",
          maxWidth: isMobile ? "100%" : "336px",

          // 🎯 الحل: الكارد ثابت تحت
          position: isMobile ? "static" : "relative",
          left: 0,
          right: 0,
          bottom: 0,

          // ☑ التحريك من تحت لفوق فقط
          transform: isMobile
            ? cardOpen
              ? "translateY(0)"
              : "translateY(calc(100% - 50px))"
            : "none",
          ...(isMobile
            ? {}
            : {
                top: cardOpen ? "0" : "18px",
                ...(isRTL
                  ? { right: cardOpen ? "0" : "18px" }
                  : { left: cardOpen ? "0" : "18px" }),
              }),
          transition: "all 0.4s ease",

          zIndex: 1000,
        }}
      >
        <CardInteractive
          isOpen={cardOpen}
          onToggle={setCardOpen}
          villa={villa}
          onOpenModal={() => setShowModal(true)}
          isMobile={isMobile}
        />
      </div>

      {/* ActiveTour */}
      <div
        style={{
          flex: 1,
              height: "calc(-50px + 100vh)",
          ...(isMobile
            ? {}
            : {
                width: "calc(100% - 336px)",
                marginInlineStart: cardOpen ? "0" : "-336px",
              }),
          transition: "all 0.4s ease",
        }}
      >
        <ActiveTour isMobile={isMobile} villa={villa} />
      </div>
      {showModal && (
        <Modal
          show={showModal}
          onClose={() => setShowModal(false)}
          type="interactive"
          villa={villa}
        />
      )}
    </div>
  );
}

export default InteractiveTour;
